import React from "react";
import { connect } from "react-redux";

import translations from "../../utils/translations";
import ScheduleIntervalItem from "./ScheduleIntervalItem";
import Colors from "../../constants/colors"; 


const ModalInterval = ({
  visible,
  intervals = [],
  columns = 2,
  onClose,
  reservationParams,
  setSelectedIntervals,
  selectedIntervals,
  onAccept,

  currentTranslations,
}) => {
  if (!visible) return null;

  const toggleInterval = (item) => {
    setSelectedIntervals((prev) => {
      const exists = prev.some(
        (i) => i.start === item.start && i.end === item.end
      );

      if (exists) {
        return prev.filter(
          (i) => !(i.start === item.start && i.end === item.end)
        );
      }

      const max = reservationParams?.max_reservations_per_day;

      if (max && prev.length >= max) {
        alert(currentTranslations?.limitReached(max));
        return prev;
      }

      return [...prev, item];
    });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.4)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        padding: "20px",
      }}
      onClick={onClose} // Cierra al hacer clic fuera
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          padding: "16px",
          width: "100%",
          maxWidth: "500px",
          maxHeight: "80vh",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        }}
        onClick={(e) => e.stopPropagation()} 
      >
        {/* Close buttton */}
        <button
          style={{
            position: "absolute",
            right: "15px",
            top: "10px",
            background: "none",
            border: "none",
            fontSize: "24px",
            color: "red",
            cursor: "pointer",
            zIndex: 50,
          }}
          onClick={onClose}
        >
          &times;
        </button>

        {/* Header */}
        <div
          style={{
            paddingBottom: "15px",
            borderBottom: "1px solid #eee",
            marginBottom: "10px",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "18px", fontWeight: 600 }}>
            {currentTranslations?.availableTimes}
          </h3>
          {reservationParams?.max_reservations_per_day && (
            <p style={{ margin: "5px 0 0 0", fontSize: "14px", color: "#666" }}>
              {currentTranslations?.selectMax} {reservationParams.max_reservations_per_day}
            </p>
          )}
        </div>

        {/* Interval list */}
        <div
          style={{
            overflowY: "auto",
            flex: 1,
            display: "grid",
            gridTemplateColumns: `repeat(${columns}, 1fr)`,
            gap: "10px",
            padding: "10px 0",
          }}
        >
          {intervals.map((item, index) => (
            <ScheduleIntervalItem
              key={`${item.start}-${item.end}-${index}`}
              item={item}
              isActive={selectedIntervals.some(
                (i) => i.start === item.start && i.end === item.end
              )}
              onPress={() => toggleInterval(item)}
            />
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            paddingTop: "15px",
            borderTop: "1px solid #eee",
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: Colors.primary,
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontWeight: 600,
              cursor: "pointer",
            }}
            onClick={onAccept}
          >
            {currentTranslations?.acceptTimes}
          </button>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
});

const mapStateToProps = (state) => ({
  currentTranslations: translations[state.app.lang],
  reservationParams: {
    max_reservations_per_day: state.access?.company?.ExtraData?.max_reservations_per_day,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalInterval);